import { SortableStoreStateOverall } from './SortableStoreStateOverall';
export class SortableExtractState {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get currentOverallState() {
        const ser = {
            parent: this.question,
            sortableItemStates: this.question.sortableStore.sortableItems.map((sortableItem) => ({
                sortableItemId: sortableItem.id_string,
                droppableId: sortableItem.droppableId,
                indexInDroppable: sortableItem.indexInDroppable,
            })),
        };
        return SortableStoreStateOverall.fromSerialized(ser);
    }
}
